import { render, staticRenderFns } from "./UpdatePlan.vue?vue&type=template&id=4d4c238b&scoped=true"
import script from "./UpdatePlan.vue?vue&type=script&lang=js"
export * from "./UpdatePlan.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlan.vue?vue&type=style&index=0&id=4d4c238b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c238b",
  null
  
)

export default component.exports